import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  VStack,
  Flex,
  Text,
  Select,
  Spinner,
  Td,
  Image,
  Button,
  useToast,
  Input,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Badge,
  Checkbox,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Circle,
  Icon,
  TabsProvider,
  useBreakpointValue,
  Avatar,
} from "@chakra-ui/react";
import {
  FaTrash,
  FaEllipsisV,
  FaPhone,
  FaEnvelope,
  FaEye,
  FaSortUp,
  FaSortDown,
  FaWhatsapp,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { TeacherContext } from "../../Context/TeacherContext";
import { useLocation } from "../../Context/LocationProvider";
import EditTeacherModal from "./EditTeacherModal";
import "./teacher.css";
import { BASE_URL } from "../../Globalapi/Globalapi";
import axios from "axios";

const TeacherTable = () => {
  const navigate = useNavigate();
  const [sortDirection, setSortDirection] = useState("asc");

  const { teachers, loading, refreshTeachers } = useContext(TeacherContext);
  const { genders } = useLocation();
  const [visibleTeachers, setVisibleTeachers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState(""); // Sorting option
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const toast = useToast();
  const [hasMore, setHasMore] = useState(true); // Add this line
  const isMobile = useBreakpointValue({ base: true, md: false });
  const INITIAL_LOAD = 100;
  const LOAD_MORE = 10;

  useEffect(() => {
    if (teachers.length > 0) {
      setVisibleTeachers(teachers.slice(0, INITIAL_LOAD));
    }
  }, [teachers]);

  useEffect(() => {
    if (teachers.length > visibleTeachers.length) {
      setHasMore(true);
    }
  }, [teachers]);

  const getGenderName = (genderId) => {
    const gender = genders.find((g) => g.id === genderId);
    return gender ? gender.gender : "Unknown";
  };

  const deleteTeacher = async (user_id) => {
    console.log("teacherd delet id", user_id);
    try {
      const response = await fetch(`${BASE_URL}/admin/staff/delete_staff.php`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id,
          pass: sessionStorage.getItem("user_id"),
        }),   
      });

      const result = await response.json();

      console.log("teacher delete:", result);

      if (result.success) {
        setVisibleTeachers((prevTeachers) =>
          prevTeachers.filter((teacher) => teacher.user_id !== user_id)
        );
        toast({
          title: "Teacher deleted.",
          description: "The teacher has been successfully deleted.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        // Show generic warning message if deletion fails
        toast({
          title: "Failed to delete.",
          description: "Try again later.",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      // console.log("delete 22",)
      console.log("delete eror---", error);
      // Network or server error
      toast({
        title: "Failed to delete.",
        description: "Try again later.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const headers = [
    "Image",
    "Name",
    "Email",
    "Date of Birth",
    "Date of Join",
    "Gender",
    "Place",
    "Class",
    "Division",
    "Guardian",
    "Status",
    "Action",
  ];

  const classes = Array.from(new Set(teachers.map((teacher) => teacher.class)));

  const handleSortChange = (option) => {
    setSortOption(option);
    const sortedTeachers = [...visibleTeachers];

    if (option === "name") {
      sortedTeachers.sort((a, b) => a.name.localeCompare(b.name));
    } else if (option === "date_of_birth") {
      sortedTeachers.sort(
        (a, b) => new Date(a.date_of_birth) - new Date(b.date_of_birth)
      );
    } else if (option === "gender") {
      sortedTeachers.sort((a, b) =>
        getGenderName(a.gender_id).localeCompare(getGenderName(b.gender_id))
      );
    }

    setVisibleTeachers(sortedTeachers);
  };

  const sortByName = () => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    const sortedTeachers = [...visibleTeachers];
    sortedTeachers.sort((a, b) =>
      sortDirection === "asc"
        ? a.name.localeCompare(b.name)
        : b.name.localeCompare(a.name)
    );
    setVisibleTeachers(sortedTeachers);
  };

  const sortByGender = () => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    const sortedTeachers = [...visibleTeachers];
    sortedTeachers.sort((a, b) =>
      sortDirection === "asc"
        ? getGenderName(a.gender_id).localeCompare(getGenderName(b.gender_id))
        : getGenderName(b.gender_id).localeCompare(getGenderName(a.gender_id))
    );
    setVisibleTeachers(sortedTeachers);
  };

  // Update your buttons in the renderRow to call these functions

  // Filter data based on search input

  // Filter data based on search input and selected option
  const filteredTeachers = visibleTeachers.filter((teacher) => {
    if (sortOption === "name") {
      return teacher.name.toLowerCase().includes(searchTerm.toLowerCase());
    } else if (sortOption === "guardian_name") {
      return teacher.guardian_name
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
    } else if (sortOption === "date_of_birth") {
      return teacher.date_of_birth
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
    } else if (sortOption === "class") {
      // Add this condition for class filtering
      return teacher.class?.toLowerCase().includes(searchTerm.toLowerCase());
    }
    return true; // If no sortOption is selected, return all teachers
  });

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredTeachers.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(filteredTeachers.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const renderRow = (teacher) => {
    return (
      <Tr key={teacher.user_id}>
        <Td py="12px" px="20px" textAlign="left">
          <Checkbox />
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          <Avatar
            src={teacher.image_url}
            alt={teacher.name}
            name={teacher.name}
            size="sm"
            objectFit="cover"
            onError={(e) => {
              e.target.src =
                "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg";
            }}
          />
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          <Link
            to={`/teachers/detail/${teacher.user_id}`}
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            {teacher.name}
          </Link>
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          {teacher.email}
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          {teacher.date_of_birth}
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          {teacher.date_of_join}
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          {getGenderName(teacher.gender_id)}
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          {teacher.place}
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          {teacher.class}
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          {teacher.division}
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          {teacher.guardian_name}
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          <Badge
            colorScheme={teacher.status === "Active" ? "green" : "green"}
            borderRadius="full"
            px={4}
            py={1}
            fontSize="11px"
            boxShadow="md"
            position="relative"
          >
            {teacher.status === "Active" ? "Active" : "Active"}
          </Badge>
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          <Flex alignItems="center" gap={2}>
            {/* Phone icon to initiate a call */}
            <Circle
              size="25px"
              bg="white"
              border="1px solid #E9EDF4"
              onClick={() => window.open(`tel:${teacher.contact_no}`, "_self")}
              cursor="pointer"
            >
              <Icon as={FaPhone} boxSize={3} color="#515B73" />
            </Circle>

            {/* WhatsApp icon to open WhatsApp */}
            <Circle
              size="25px"
              bg="white"
              border="1px solid #E9EDF4"
              onClick={() =>
                window.open(`https://wa.me/${teacher.contact_no}`, "_blank")
              }
              cursor="pointer"
            >
              <Icon as={FaWhatsapp} boxSize={3} color="#25D366" />
            </Circle>

            {/* Ellipsis icon for the menu options */}
            <Menu>
              <MenuButton as={IconButton} icon={<FaEllipsisV />} size="sm" />
              <MenuList>
                <MenuItem
                  onClick={() =>
                    navigate(`/teachers/detail/${teacher.user_id}`)
                  }
                  icon={<FaEye color="black" />}
                >
                  View Teacher
                </MenuItem>
                <MenuItem>
                  <EditTeacherModal
                    teacherId={teacher.user_id}
                    onTeacherUpdated={refreshTeachers}
                  />
                </MenuItem>
                <MenuItem
                  onClick={() => deleteTeacher(teacher.user_id)}
                  icon={<FaTrash color="red" />}
                >
                  Delete
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Td>
      </Tr>
    );
  };

  return (
    <Box p={6} maxWidth="100%" overflowX="auto">
      <Flex
        direction={isMobile ? "column" : "row"}
        justify="space-between"
        align="center"
        className="sb"
        // mb={1}
        p={3}
      >
        {/* Rows Per Page Section */}
        <Flex direction="row" align="center" mb={isMobile ? 4 : 0}>
          <Text mr={1} whiteSpace="nowrap">
            Rows Per Page
          </Text>
          <Select
            width="100px"
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            borderColor="#E9EDF4"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Select>
        </Flex>

        {/* Sort and Search Section */}

        <Stack
          direction={isMobile ? "column" : "row"}
          w={{ base: "100%" }}
          justify="end"
          spacing={4}
        >
          <Select
            placeholder="Search by"
            borderColor="#E9EDF4"
            color="#515B73"
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            w={{ base: "100%", md: "200px" }}
          >
            <option value="name">Name</option>
            <option value="guardian_name">Guardian Name</option>
            <option value="date_of_birth">Date of Birth</option>
            <option value="class">Class</option> {/* Add this line */}
          </Select>

          <Input
            type="text"
            placeholder={`Search by ${
              sortOption
                ? capitalizeFirstLetter(sortOption.replace(/_/g, " "))
                : ""
            }`}
            value={searchTerm}
            borderColor="#E9EDF4"
            onChange={(e) => setSearchTerm(e.target.value)}
            w={{ base: "100%", md: "200px" }}
          />
        </Stack>
      </Flex>

      <Box
        borderWidth="1px"
        borderRadius="md"
        overflowx="auto"
        style={{ overflowX: "auto" }}
      >
        <Table
          sx={{
            "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            td: {
              whiteSpace: "nowrap", // Prevent text from wrapping
            },
          }}
        >
          <Thead>
            <Tr>
              <Th>
                <Checkbox />
              </Th>
              <Th>Image</Th>
              <Th>
                <Flex align="center">
                  Name
                  <Button onClick={sortByName} variant="link" ml={2} p={0}>
                    <Icon
                      as={sortDirection === "asc" ? FaSortUp : FaSortDown}
                    />
                  </Button>
                </Flex>
              </Th>

              <Th>Email</Th>
              <Th>DoB</Th>
              <Th>DoJ</Th>
              <Th>
                <Flex align="center">
                  <Text>Gender</Text>
                  <Button onClick={sortByGender} variant="link" ml={2}>
                    {sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />}
                  </Button>
                </Flex>
              </Th>

              <Th>Place</Th>
              <Th>Class</Th>
              <Th>Division</Th>
              <Th>Guardian</Th>
              <Th>Status</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>

          <Tbody>
            {loading ? (
              <Tr>
                <Td colSpan={headers.length} textAlign="center">
                  <Spinner size="xl" />
                </Td>
              </Tr>
            ) : (
              currentData.map((teacher) => renderRow(teacher))
            )}
          </Tbody>
        </Table>
      </Box>

      <Flex justify="end" borderTopWidth="1px" className="sb2" p={3}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>
        <Stack direction="row" mx={2}>
          {currentPage > 1 && (
            <>
              <Button onClick={() => handlePageChange(1)}>1</Button>
              {currentPage > 2 && <Text>...</Text>}
            </>
          )}
          <Button backgroundColor="teal" color="white">
            {currentPage}
          </Button>
          {currentPage < totalPages - 1 && (
            <>
              <Text>...</Text>
              <Button onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Button>
            </>
          )}
        </Stack>
        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};

export default TeacherTable;
